const STAGING_AI_INSIGHTS_URL = 'https://staging-ai-insights-and-trends-fekv67xtza-ew.a.run.app';

const ENV_CONFIG = {
  // Opt-in build for bridged-local-stack: set REACT_APP_BRIDGED_ENV=local at build time
  local: {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:4300',
    FLIPCARD_URL: process.env.REACT_APP_IFRAME_URL || 'http://localhost:4100',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
    AI_INSIGHTS_URL: process.env.REACT_APP_AI_INSIGHTS_URL || STAGING_AI_INSIGHTS_URL,
  },

  dev: {
    API_URL: 'https://dev-gateway.bridged.media',
    FLIPCARD_URL: 'https://dev-agent-card.bridged.media',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
  },

  staging: {
    API_URL: 'https://stg-gateway.bridged.media',
    FLIPCARD_URL: 'https://stg-agent-card.bridged.media',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
  },

  production: {
    API_URL: 'https://gateway.bridged.media',
    FLIPCARD_URL: 'https://agent-card.bridged.media',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
  },
};

const hostname = window.location.hostname;

const LOCAL_ENV_KEY = 'localApiEnv';
const DEFAULT_LOCAL_ENV = 'staging';

export const LOCAL_ENVS = Object.keys(ENV_CONFIG);
// Every Bridged gateway, so an OAuth authorize request can be checked against them
export const GATEWAY_ORIGINS = Object.values(ENV_CONFIG).map(
  ({ API_URL }) => new URL(API_URL).origin
);
export const IS_LOCALHOST = hostname.includes('localhost');

// Locally, `?env=` wins and is remembered; otherwise the last choice from the env switcher is used.
function getLocalEnvironmentName() {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get('env');

  try {
    if (fromUrl && ENV_CONFIG[fromUrl]) {
      localStorage.setItem(LOCAL_ENV_KEY, fromUrl);
      return fromUrl;
    }

    const saved = localStorage.getItem(LOCAL_ENV_KEY);
    if (saved && ENV_CONFIG[saved]) {
      return saved;
    }
  } catch {}

  return DEFAULT_LOCAL_ENV;
}

export const LOCAL_ENV = IS_LOCALHOST ? getLocalEnvironmentName() : null;

// Each env has its own login, so keep a token pair per env and swap them on switch.
export function switchLocalEnvironment(nextEnv) {
  if (!IS_LOCALHOST || !ENV_CONFIG[nextEnv] || nextEnv === LOCAL_ENV) return;

  const tokenKeys = ['accessToken', 'refreshToken'];
  const stashKey = env => `${LOCAL_ENV_KEY}:tokens:${env}`;

  const current = Object.fromEntries(tokenKeys.map(key => [key, localStorage.getItem(key)]));
  localStorage.setItem(stashKey(LOCAL_ENV), JSON.stringify(current));

  let next = {};
  try {
    next = JSON.parse(localStorage.getItem(stashKey(nextEnv))) || {};
  } catch {}
  tokenKeys.forEach(key => {
    if (next[key]) localStorage.setItem(key, next[key]);
    else localStorage.removeItem(key);
  });

  localStorage.setItem(LOCAL_ENV_KEY, nextEnv);

  const url = new URL(window.location.href);
  url.searchParams.delete('env');
  window.location.replace(url.toString());
}

function resolveEnvironment() {
  // build-time local stack setting wins over every hostname rule
  if (process.env.REACT_APP_BRIDGED_ENV === 'local') {
    return ENV_CONFIG.local;
  }

  // localhost behavior
  if (IS_LOCALHOST) {
    return ENV_CONFIG[LOCAL_ENV];
  }

  // deployed staging
  if (hostname.includes('stg')) {
    return ENV_CONFIG.staging;
  }

  // deployed dev
  if (hostname.includes('dev')) {
    return ENV_CONFIG.dev;
  }

  // production fallback
  return ENV_CONFIG.production;
}

const currentEnv = resolveEnvironment();

export const { API_URL, FLIPCARD_URL, PLUGIN_ID } = currentEnv;

export const AI_INSIGHTS_URL = currentEnv.AI_INSIGHTS_URL || STAGING_AI_INSIGHTS_URL;
